import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { getMarkerEndpoints } from '../../../utils/adsMarker';
import FormatUtils from '../../../utils/FormatUtils';

const MinMaxHelper = ({ markers, markerId, episodeDuration }) => {
  const [minStart, maxStart] = getMarkerEndpoints(markers, markerId, episodeDuration);

  if (minStart > 0 && maxStart === episodeDuration) {
    return (
      <FormattedMessage
        defaultMessage="This marker cannot be less: {minimum}"
        values={{ minimum: FormatUtils.formatTimeHundredthSeconds(minStart) }}
      />
    );
  } else if (maxStart < episodeDuration && minStart === 0) {
    return (
      <FormattedMessage
        defaultMessage="This marker cannot be greater than: {maximum}"
        values={{ maximum: FormatUtils.formatTimeHundredthSeconds(maxStart) }}
      />
    );
  } else {
    return (
      <FormattedMessage
        defaultMessage="This marker must be between {minimum} and {maximum}"
        values={{
          minimum: FormatUtils.formatTimeHundredthSeconds(minStart),
          maximum: FormatUtils.formatTimeHundredthSeconds(maxStart),
        }}
      />
    );
  }
};

export default MinMaxHelper;

MinMaxHelper.propTypes = {
  markers: PropTypes.array.isRequired,
  markerId: PropTypes.string.isRequired,
  episodeDuration: PropTypes.number.isRequired,
};
